import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { IframeSlideInvestimentsComponent } from '../iframe-slide-investiments/iframe-slide-investiments.component';

import { getConsultingSelectors } from './store/consulting.selectors';
import { setConsultingAction } from './store/consulting.actions';
import { IConsultingState } from './store/consulting.state';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { IConsultantModelData } from 'src/app/modules/interfaces/investments.interface';
import { InvestmentsService } from 'src/app/services/investments.service';
import { getCookie } from 'src/app/utils/get-cookie';

@Component({
  selector: 'app-consulting-model',
  templateUrl: './consulting-model.component.html',
  styleUrls: ['./consulting-model.component.scss'],
})
export class ConsultingModelComponent implements OnInit {
  @ViewChild('meuIframe') meuIframe: ElementRef;
  @Output() formSaved = new EventEmitter<void>();
  @Output() ConsultingInterest = new EventEmitter<boolean>();

  consulting: boolean;
  iframeVisivel: boolean = false;
  consultingState: IConsultingState;
  consultingState$: Observable<any>;

  formsId: number;
  consultantData: IConsultantModelData = {
    investmentId: 0,
    wants_investment_model: 0,
  };

  constructor(
    public dialog: MatDialog,
    private store: Store,
    private investmentsService: InvestmentsService
  ) {
    this.formsId = Number(getCookie('formsId'));
  }

  ngOnInit(): void {
    this.getState();
    this.loadInvestmentsData();
    this.consulting = this.consultingState.interest;
  }

  loadInvestmentsData(): void {
    this.investmentsService
      .getInvestmentsData(this.formsId)
      .subscribe((response) => {
        if (response) {
          this.consultantData = {
            investmentId: response.id,
            wants_investment_model: response.wants_investment_model,
          };
          this.saveState()
        }
      });
  }

  saveForm(): void {
    console.log("to sendo chamado")
    const updateData = {
      wants_investment_model: this.consultantData.wants_investment_model
        ? 1
        : 0,
    };

    this.investmentsService
      .updateInvestmentsData(
        this.formsId,
        this.consultantData.investmentId,
        updateData
      )
      .subscribe({
        next: () => {
          this.saveState()
          this.formSaved.emit();
        },
        error: (error) => {
          console.error(error);
        },
      });
  }
  
  saveState():void {
    this.consultingState = {
      interest: this.consultantData.wants_investment_model === 1
    }
  }

  openDialog() {
    const dialogRef = this.dialog.open(IframeSlideInvestimentsComponent, {
      panelClass: 'iframe-dialog',
    });
    dialogRef.afterClosed().subscribe();
  }

  ativarModoTelaCheia() {
    this.iframeVisivel = true;
    const iframeElement = this.meuIframe.nativeElement;
    if (iframeElement.requestFullscreen) {
      iframeElement.requestFullscreen();
    } else if (iframeElement.mozRequestFullScreen) {
      iframeElement.mozRequestFullScreen();
    } else if (iframeElement.webkitRequestFullscreen) {
      iframeElement.webkitRequestFullscreen();
    }
  }

  updateConsulting() {
    this.ConsultingInterest.emit(this.consulting);
    this.consultingState.interest = this.consulting;
    this.setState(this.consultingState);
  }

  getState() {
    this.consultingState$ = this.store.select(getConsultingSelectors);
    this.consultingState$.subscribe((value) => {
      this.consultingState = {
        ...(this.consultingState = value),
      };
    });
  }

  setState(data: IConsultingState) {
    this.store.dispatch(setConsultingAction(data));
  }
}
